import {MeshBasicMaterial} from 'three';

export const LIGHT_HELPER_MAT = new MeshBasicMaterial({wireframe: true, fog: false});
